export default __webpack_public_path__ + "static/media/LegacyRealEstate.60334bee.jpg";